import React, { useState, useContext } from 'react';
import 'bulma/css/bulma.min.css';

import { BeamlineContext } from '../beamlineProvider.tsx';
import { Uid } from "./../utils.tsx";


interface DeleteParametersProps {
  selection: Uid[];
}

const DeleteParameters: React.FC<DeleteParametersProps> = (props) => {

  const beamlineContext = useContext(BeamlineContext);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [inProgress, setInProgress] = useState<boolean>(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState<string | null>(null);


  function clickedOpen() {
    if (!inProgress && !isOpen && props.selection.length > 0) {
      setIsOpen(true);
    }
  }

  async function pressedSubmit() {
    setSubmitErrorMessage(null);
    setInProgress(true);
    const result = await beamlineContext.scanTypes.deleteParametersFromServerAndRemove(props.selection);
    beamlineContext.changed();
    setInProgress(false);
    if (!result.success) {
      setSubmitErrorMessage(result.message || "");
    } else {
      setIsOpen(false);
    }
  };

  function clickedClose() {
    if (!inProgress) { setSubmitErrorMessage(null); setIsOpen(false); }
  }

  const plural = props.selection.length > 1 ? "s" : "";

  const s = beamlineContext.scanTypes;
  const scanTypesAffected = s.typeSlugsInDisplayOrder.filter((slug) => {
    const scanType = s.typesBySlug.get(slug);
    if (!scanType) { return false; }
    return scanType.parameterIds.some((id) => props.selection.includes(id));
  }).map((slug) => s.typesBySlug.get(slug)!);

  return (
    <a className="dropdown-item" onClick={ clickedOpen }>Delete Parameter{ plural }

      <div id="modal-add-sample" className={ isOpen ? "modal is-active" : "modal" }>
        <div className="modal-background"></div>

        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Delete Parameter{ plural }</p>
            <button className="delete" aria-label="close" onClick={ clickedClose }></button>

          </header>
          <section className="modal-card-body">

            <div className="block">
              <p>
                Are you sure you want to delete { props.selection.length } parameter{ plural }?
              </p>
            </div>
            <div className="block">
              { scanTypesAffected.length > 0 && (
                <>
                  <p>
                    This will also remove the parameter{ plural } from the following Scan Types:
                  </p>
                  <ul style={{ listStyleType: "circle", marginLeft: "2em" }}>
                    { scanTypesAffected.map((s) => (
                      <li key={s.id}>{s.name}</li>
                    )) }
                  </ul>
                </>
              )}
            </div>
            <div className="block">
              <p>
                <b>This operation cannot be undone!</b>
              </p>
            </div>

            <div className="buttons">
              <input
                type="button"
                className="button is-danger"
                onClick={ pressedSubmit }
                disabled={ inProgress }
                value="Delete"
              />
              <button className="button" onClick={ clickedClose }>Cancel</button>
            </div>

            { submitErrorMessage && (
              <article className="message is-danger">
                <div className="message-body">
                  { submitErrorMessage }
                </div>
              </article>
            )}

          </section>

        </div>
      </div>

    </a>
  )
}
export default DeleteParameters
